var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value !== null
    ? _c(
        "section",
        { staticClass: "data pega-print-break-inside-avoid" },
        [
          _c("p", { staticClass: "hd-type-04 mr5" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))]),
          ]),
          _vm._v(" "),
          _c("job-preview-content-data-tooltip-sp"),
          _vm._v(" "),
          _c("div", { staticClass: "palette" }, [
            _c("div", { staticClass: "colorOuter", class: _vm.colorClass }, [
              _c("div", {
                staticClass: "colorInner",
                style: "transform: rotate(" + _vm.rotateTurn + "turn);",
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "centerOverlay fwB" }, [
              _c("span", { staticClass: "head" }, [_vm._v("女性")]),
              _vm._v(" "),
              _c("span", { staticClass: "half tr" }, [
                _vm._v(_vm._s(_vm.value)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "half" }, [_vm._v("％")]),
              _vm._v(" "),
              _c("div", { staticClass: "north" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "separator",
                style:
                  "transform: rotate(" +
                  _vm.rotateTurn +
                  "turn) translate(0px, -50px);",
              }),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }